import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import { cancelDraft } from "@services/subscriberSyncUpload";

// Mirrors useDeleteMeterUploadDraft: always invalidate the upload-history query, THEN run any caller
// onSuccess. Structuring it this way (rather than letting a passed onSuccess replace the built-in
// handler) ensures the list refreshes whether the draft is cancelled from the review footer or the
// upload-history list.
export const useCancelSubscriberSyncDraft = ({
  onSuccess,
  ...options
}: Record<string, any> = {}) => {
  const queryClient = useQueryClient();
  return useMutation((id: string) => cancelDraft(id), {
    ...options,
    onSuccess: (res: void, id: string) => {
      queryClient.invalidateQueries({ queryKey: ["subscriberSyncUploads"] });
      if (isFunction(onSuccess)) onSuccess(res, id);
    },
  });
};
